<template>
<div class="g-bg-img-hero" style="background-image: url('../../../../static/assets/include/svg/svg-bg1.svg');">
    <div class="container g-py-30">
      <!-- Heading -->
      <div class="g-max-width-700 text-center mx-auto g-mb-60">
        <h2 class="h1" id="errorDiv">Resources</h2>
        <p class="g-font-size-20">This page contains resources to help you engage in your community.  If you are looking for help using or navigating this website, check out the <a class="g-font-size-20 g-link-bold" v-on:click="RouterRedirect('Help')">Help page</a>.</p>
      </div>
      <div v-if="cardItems != null" v-for="(parentItem, parentIdx) of cardItems" class="card-group d-block d-md-flex g-mx-minus-4">
        <div v-for="(item, itemIdx) of parentItem" class="card g-brd-none g-mx-4 g-mb-8 u-shadow-v38">
          <!-- Links -->
          <div v-if="item.type === 'Card'">
            <div class="card-body g-bg-white rounded g-pa-40">
              <img v-if="item.iconURL !== null" :src="item.iconURL" class="resource-page-icon g-mb-20"/>
              <h3 class="h3">
                <strong v-if="item.isNew" style="color: rgb(166, 29, 55);">New! </strong>
                <span v-html="item.title"></span>
              </h3>
              <p class="g-color-text-light-v1 g-font-size-20--md g-font-size-18"><span v-html="item.description"></span></p>
            </div>
            <div class="g-view-document g-px-40">
              <a v-if="!item.isModal && !item.isLocalLInk" :href="item.linkURL" class="u-link-v5 g-color-main--hover g-font-size-20--md g-font-size-18" target="_blank"><span v-html="item.linkText"></span></a>
              <a v-if="!item.isModal && item.isLocalLInk" class="u-link-v5 g-color-main--hover g-font-size-20--md g-font-size-18" v-on:click="RouterRedirect(item.linkURL)"><span v-html="item.linkText"></span></a>
              <a v-if="item.isModal" class="u-link-v5 g-color-main--hover g-font-size-20--md g-font-size-18" @click="ToggleJotForm(item.jotFormID)"><span v-html="item.linkText"></span></a>
              <a v-if="item.downloadURL != null" :href="item.downloadURL" target="_blank" download="EVF Resource FIle" class="g-float-right g-color-main g-color-primary--hover"><i class="fa fa-2x fa fa-arrow-circle-down" aria-hidden="true"></i></a>
            </div>
          </div>
          <div v-if="item.type === 'List'">
            <div class="card-body g-bg-white rounded">
              <div class="row">
                <div class="col-sm-8">
                  <strong v-html="item.title"></strong>
                  <p class="g-color-text-light-v1"><span v-html="item.description"></span></p>
                </div>
                <div class="col-sm-4 box">
                  <div class="row center-icon">
<!--                    <div class="col-sm-12" style="background-color: purple;">-->
                      <a v-if="!item.isModal && !item.isLocalLInk" :href="item.linkURL" style="padding-left: 50px;" class="u-link-v5 g-color-main--hover " target="_blank"><span v-html="item.linkText"></span></a>
                      <a v-if="!item.isModal && item.isLocalLInk" style="padding-left: 50px;" class="u-link-v5 g-color-main--hover  " v-on:click="RouterRedirect(item.linkURL)"><span v-html="item.linkText"></span></a>
                      <a v-if="item.isModal" style="padding-left: 50px;" class="u-link-v5 g-color-main--hover " @click="ToggleJotForm(item.jotFormID)"><span v-html="item.linkText"></span></a>
                      <a v-if="item.downloadURL != null" :href="item.downloadURL" target="_blank" download="EVF Resource FIle" class="g-float-right g-color-main g-color-primary--hover"><i class="fa fa-2x fa fa-arrow-circle-down" aria-hidden="true"></i></a>
<!--                    </div>-->
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- End Links -->
        </div>
      </div>
           <jotform-modal v-if="showJotForm" @closeJotForm="ToggleJotForm" :Account="Account" :formID="jotFormID"></jotform-modal>
      </div>
    </div>
</template>
<script>
import HeaderComponent from "@/components/shared/HeaderComponent";
import FooterComponent from "@/components/shared/FooterComponent";
import PageLoader from "@/components/shared/PageLoader";
import JotformModal from "@/components/shared/JotformModal";
import Vue from 'vue';
export default {
        components: {HeaderComponent, FooterComponent, PageLoader, JotformModal},
  data(){
    return{
      Account:{},
      cardItems: [],
      jotFormID: null,
      showJotForm: false,
      showWufooForm: false,
      showStockForm: false,
      ShowStockLensTile: false,
      showPrintableForm: false    }
  },
  methods:{
    RouterRedirect(path){
      this.$router.push({path: path});
    },
    ToggleJotForm(jotFormID){
        this.jotFormID = jotFormID;
        this.showJotForm = !this.showJotForm;
        if(this.showJotForm){
            document.body.classList.add("body-overflow");
        }
        else{
            document.body.classList.remove("body-overflow");
        }
    },
    GetAccountValues(){
            var _this = this;
            axios.get('/Account/Self', {headers: {'Authorization': "Bearer " + localStorage.getItem("token")}})
            .then(function (response) {
                 _this.Account = response.data.raw;
                 localStorage.setItem("customUserPermissionFlag", _this.Account.customUserPermissionFlag);
                 _this.ShowStockLensTile = _this.Account.customUserPermissionFlag.includes("Show Stock Lens Tile");
                 //_this.ExistingStockUser = _this.Account.customUserPermissionFlag.includes("Existing Stock Lens User");
            })
            .catch(function (error) {
                console.log(error);
            });
    }
  },
  async mounted() {
      console.log("modal mounted");
  },

  async created(){
      this.GetAccountValues();
      console.log("modal created");
          try {
            const portalType = window.location.href.includes("changinglifethroughlenses") ? "CLTL" : "CFS";

            const apiUrl = `${Vue.config.API_ENDPOINT}CMS/GetResourcesItems?portalType=${portalType}`;

            const response = await fetch(apiUrl, {
              method: 'get',
              headers: {
                  'Authorization': "Bearer " + localStorage.getItem("token")
              }
            });

            console.log(response);
            let apiitems = await response.json();
            apiitems = [...apiitems].sort((x,y) => (x.sortOrder||99999) - (y.sortOrder||99999));
            apiitems = [...apiitems].sort((x,y) => {
              if (x.type < y.type) {
                return -1;
              } else if(x.type > y.type) {
                return 1;
              } else {
                return 0;
              }
            });
            console.log("API items");
            console.log(apiitems);

            let parentFlex = [];
            let parentIdx = 0;
            let childIdx = 0;
            //for(;srcIdx < apiitems.length;)
            for (let x of apiitems)
            {
              // if ((x.type === 'List' && childIdx > 0) ||
              //     (x.type === 'Card' && childIdx > 1))
              // {
              //   console.log("move");
              //     childIdx = 0;
              //     parentIdx++;
              // }

              // console.log(x.type);
              // console.log("childIdx");
              // console.log(childIdx);
              // console.log("parentIdx");
              // console.log(parentIdx);

              if (parentFlex[parentIdx] === undefined)
                parentFlex[parentIdx] = [];

              parentFlex[parentIdx][childIdx] = x;
              parentFlex[parentIdx][childIdx].isModal = x.linkURL.startsWith("#");
              parentFlex[parentIdx][childIdx].isLocalLInk = !x.linkURL.startsWith("http");

              if (parentFlex[parentIdx][childIdx].isModal)
                parentFlex[parentIdx][childIdx].jotFormID = x.linkURL.substring(1);

              //console.log(parentFlex[parentIdx][childIdx]);
              childIdx++;

              if (x.type === 'List')
              {
                childIdx = 0;
                parentIdx++;
              }
              // else if (childIdx > 1)
              // {
              //   childIdx = 0;
              //   parentIdx++;
              // }
              if (childIdx >= x.columnWidth)
              {
                childIdx = 0;
                parentIdx++;
              }
            }
            this.cardItems = parentFlex;
        } catch(ex) {
            console.log(ex);
        }

  }
}





</script>



// WEBPACK FOOTER //
// ResourceServices.vue?5f19e6a4